module.exports = __webpack_public_path__ + "img/trump.5dfea5b6.png";